"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Cloud, TrendingUp, Shield } from "lucide-react";
export default function CloudAccountingHero() {
  return <section id="hero" className="
        relative w-full min-h-screen flex items-center justify-center
        bg-cover bg-center bg-no-repeat
        !bg-[url(https://sloane.uk/wp-content/uploads/2026/02/cloud_accounting_tablet.webp)]
      ">
      <div className="relative max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-24 md:py-32">
        <div className="flex flex-col items-center text-center space-y-8 md:space-y-10 !text-[hsl(210,11%,71%)]">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight text-foreground max-w-5xl">
            Cloud Accounting
            <span className="block mt-2 text-primary">For Your Business</span>
          </h1>

          <p className="text-lg max-w-3xl leading-relaxed sm:text-xl md:text-2xl !text-[hsl(0,0%,0%)]">
            Experience seamless financial management with real-time insights,
            automated processes, and secure cloud-based solutions. Transform
            the way you handle your accounts.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 items-center">
            <Button asChild size="lg" className="btn-primary text-base px-8 py-6 h-auto">
              
            </Button>

            <Button asChild variant="outline" size="lg" className="text-base px-8 py-6 h-auto bg-white/10 hover:bg-white/20 border-white/20 text-white">
              
            </Button>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 md:gap-12 pt-12 md:pt-16 max-w-4xl w-full !bg-transparent">
            <div className="flex flex-col items-center space-y-3">
              <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center">
                <Cloud className="w-8 h-8 text-primary" />
              </div>
              <h3 className="text-lg !text-[hsl(224,76%,48%)] !font-bold">Cloud-Based</h3>
              <p className="text-sm !font-bold !text-[hsl(0,0%,0%)]">Access anywhere, anytime</p>
            </div>

            <div className="flex flex-col items-center space-y-3">
              <div className="w-16 h-16 rounded-full bg-accent/10 flex items-center justify-center">
                <TrendingUp className="w-8 h-8 text-accent-dark" />
              </div>
              <h3 className="text-lg !text-[hsl(224,76%,48%)] !font-bold">Real-Time Insights</h3>
              <p className="text-sm !font-bold !text-[hsl(0,0%,0%)]">Data-driven decisions</p>
            </div>

            <div className="flex flex-col items-center space-y-3">
              <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center">
                <Shield className="w-8 h-8 text-primary" />
              </div>
              <h3 className="text-lg !text-[hsl(224,76%,48%)] !font-bold">Secure & Compliant</h3>
              <p className="text-sm !font-bold !text-[hsl(0,0%,0%)]">Bank-level security</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}